import { FastQuestionTranslation } from '@/assets/locales/views/employeeProfile/sections/chat/employeeProfile.chat.translation.en.ts';

export const employeeProfileChatFastQuestionsManagerTranslation: FastQuestionTranslation = {
  fastQuestionButtons: {
    question1: 'Feedback',
    question10: 'EducAction training',
    question2: 'Match projects',
    question3: 'Key competencies',
    question4: 'Promotion',
    question5: 'Delegating tasks',
    question6: 'Recommended books',
    question7: 'Motivation',
    question8: 'Conflict resolution',
    question9: 'Open learning trainings',
  },
  fastQuestionTexts: {
    question1: 'How to give feedback to an employee?',
    question10: 'What EducAction training do you recommend for my employee?',
    question2: 'In what types of projects could an employee perform best?',
    question3: 'What competencies are key for development in the current position of an employee?',
    question4: 'What competencies must my employee develop to advance one level in the structure?',
    question5:
      'How to effectively delegate tasks that will help the employee develop the necessary competencies?',
    question6:
      'What books can I recommend to an employee that support his professional development plan?',
    question7: 'How to motivate an employee to work on their development?',
    question8: 'How can I resolve a conflict in a team in which the employee is involved?',
    question9: 'What open learning trainings do you recommend for my employee?',
  },
};
